import angular from 'angular';
import ChangeFdoDateModalComponent from './change.fdo.date.modal.component';
export default angular.module('inv.customer.orderHistory.orderDetails.changeFdoDateModal', []).component('changeFdoDateModal', ChangeFdoDateModalComponent).name;